import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import { fromPage } from '@blade-sxp/search-center/interfaces/enum';
import colors from '@/styles/color.scss';
import moment from 'moment';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import DrawWithImg from '@blade/common/components/paint/draw-with-img.vue';
import { getFeatureInfoByObjectId } from '@blade-sxp/monitor-center/api/index';
let Details = class Details extends Vue {
    visible;
    list;
    data;
    imgUrl;
    multiples = 1;
    moment = moment;
    info = null;
    image;
    layerVal = true;
    count = 0;
    loading = false;
    isBlur = localStorage.getItem('privacyMode') === 'true';
    routepage = fromPage.FEATURES_PAGE;
    featuresStr = '';
    featuresList = [];
    backImageUrl = require('@blade-sxp/search-center/assets/images/back.png');
    nextImageUrl = require('@blade-sxp/search-center/assets/images/right.png');
    routeImageUrl = require('@blade-sxp/search-center/assets/images/route.png');
    fullScreenImgFlag = false;
    showAllFeature = false;
    filterImgLv = 0;
    option = {
        normal: {
            fillStyle: '#0077FA',
            globalAlpha: 0.3,
            lineWidth: 2,
            strokeStyle: '#3295FB',
        },
    };
    dataSource = [];
    headPoint = [];
    drawButtons = ['polygon', 'rect'];
    headPointStatus = true;
    imageStyle = {
        width: 800,
        height: 451,
    };
    get showFeaturesList() {
        if (this.showAllFeature)
            return this.info?.features || [];
        return this.info?.features.slice(0, 10) || [];
    }
    showAllFeatureFn() {
        this.showAllFeature = !this.showAllFeature;
    }
    next() {
        const index = this.list.findIndex((e) => e === this.data);
        if (index < 0)
            return;
        if (index < this.list.length - 1) {
            this.layerVal = true;
            this.$emit('update:data', this.list[index + 1]);
        }
    }
    prev() {
        const index = this.list.findIndex((e) => e === this.data);
        if (index < 0)
            return;
        if (index > 0) {
            this.layerVal = true;
            this.$emit('update:data', this.list[index - 1]);
        }
    }
    changeSwitch(val) {
        this.drawFace();
    }
    onDataChange(val) {
        this.getDetail();
    }
    // @Watch('layerVal', { immediate: true })
    // onlayerValChange(val: Boolean) {
    //   this.drawFace();
    // }
    onVisibleChange(val) {
        this.layerVal = true;
        // this.layerVal && this.drawFace();
    }
    getDetail() {
        if (!this.data.objectId)
            return;
        this.loading = true;
        const params = {
            externalBizFrom: '',
            objectId: this.data.objectId,
            deviceId: this.data.deviceId,
            objectType: 'OBJECT_FACE',
        };
        getFeatureInfoByObjectId(params)
            .then((res) => {
            this.info = Object.values(res)[0];
            this.drawFace();
        })
            .finally(() => {
            this.loading = false;
        });
    }
    drawFace() {
        // 重复获取
        this.$nextTick(() => {
            if (!this.info)
                return;
            if (this.image?.url === this.info.panoramicImage) {
                return this.drawCanvas(this.image.img);
            }
            const img = new Image();
            img.src = this.info.panoramicImage;
            img.crossOrigin = '';
            this.image = {
                url: this.info.panoramicImage,
                img,
            };
            // 加载图片
            img.onload = () => {
                if (img.complete) {
                    this.drawCanvas(img);
                }
            };
        });
    }
    drawCanvas(img) {
        const canvas = this.$refs.mycanvas;
        if (!canvas) {
            return false;
        }
        const context = canvas.getContext('2d');
        // 根据图像重新设定了canvas的长宽
        const { height, width } = img;
        canvas?.setAttribute('width', String(width));
        canvas?.setAttribute('height', String(height));
        // 绘制图片
        context?.drawImage(img, 0, 0, width, height); // 画布大小
        context.lineWidth = 0.01;
        context.strokeStyle = colors.white; // 矩形线颜色
        context.fillStyle = 'transparent';
        const imageData = this.info?.personGroups[0].targets;
        if (imageData && this.layerVal) {
            this.loading = true;
            imageData.forEach((coordinate) => {
                const coordinates = coordinate.rectangle;
                const x = coordinates.vertices[0].x;
                const y = coordinates.vertices[0].y;
                const rightX = coordinates.vertices[1].x - x;
                const rightY = coordinates.vertices[1].y - y;
                const startX = x;
                const startY = y;
                const endX = Math.abs(rightX);
                const endY = Math.abs(rightY);
                context?.strokeRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                context?.fillRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                this.loading = false;
                context.stroke();
                let rectWidth = Math.max(12, endX * 0.2, endY * 0.2);
                rectWidth = Math.min(rectWidth, 35);
                const rectHeight = 5;
                // 绘制4个直角
                context.fillStyle = colors.white;
                context.fillRect(startX, startY, rectWidth, rectHeight);
                context.fillRect(startX, startY, rectHeight, rectWidth);
                context.fillRect(startX, startY + endY - rectWidth, rectHeight, rectWidth);
                context.fillRect(startX, startY + endY - rectHeight, rectWidth, rectHeight);
                context.fillRect(startX + endX - rectWidth, startY, rectWidth, rectHeight);
                context.fillRect(startX + endX - rectHeight, startY, rectHeight, rectWidth);
                context.fillRect(startX + endX - rectHeight, startY + endY - rectWidth, rectHeight, rectWidth);
                context.fillRect(startX + endX - rectWidth, startY + endY - rectHeight, rectWidth, rectHeight);
            });
        }
    }
    closeDetails() {
        this.$emit('update:visible', false);
        this.multiples = 1;
    }
    onFullScreen(type) {
        if (type === 1) {
            this.fullScreenImgFlag = true;
        }
        else {
            this.fullScreenImgFlag = false;
        }
        this.$refs.imgaeScrenn.clickHandler();
        const filterClassName = ['-webkit-filter', '-moz-filter', '-ms-filter', 'filter'];
        this.$nextTick(() => {
            filterClassName.forEach((item) => {
                document.getElementsByClassName('el-image-viewer__canvas')[0].style[item] = `blur(${this.filterImgLv}px)`;
            });
        });
    }
    handleFullScreen(img) {
        window.open(this.$router.resolve({
            path: img,
        }).href, '_blank');
    }
    toBIgChange() {
        // if (this.multiples >= 1) {
        //   return;
        // }
        this.multiples += 0.25;
    }
    // 缩小
    toSmallChange() {
        if (this.multiples <= 0.3) {
            return;
        }
        this.multiples -= 0.25;
    }
};
__decorate([
    Prop()
], Details.prototype, "visible", void 0);
__decorate([
    Prop()
], Details.prototype, "list", void 0);
__decorate([
    Prop()
], Details.prototype, "data", void 0);
__decorate([
    Prop({ default: '' })
], Details.prototype, "imgUrl", void 0);
__decorate([
    Watch('data', { immediate: true, deep: true })
], Details.prototype, "onDataChange", null);
__decorate([
    Watch('visible', { immediate: true })
], Details.prototype, "onVisibleChange", null);
Details = __decorate([
    Component({
        name: 'Details',
        components: { BlurPicture, 'st-darw-width-img': DrawWithImg },
        directives: {
            drag: {
                // 指令的定义
                bind: function (el) {
                    // 获取当前元素
                    let oDiv = el;
                    oDiv.onmousedown = (e) => {
                        // 算出鼠标相对元素的位置
                        let disX = e.clientX - oDiv.offsetLeft;
                        let disY = e.clientY - oDiv.offsetTop;
                        document.onmousemove = (e) => {
                            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                            let left = e.clientX - disX;
                            let top = e.clientY - disY;
                            oDiv.style.left = left + 'px';
                            oDiv.style.top = top + 'px';
                        };
                        document.onmouseup = () => {
                            document.onmousemove = null;
                            document.onmouseup = null;
                        };
                    };
                },
            },
        },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Details);
export default Details;
